import React, { createContext, useContext } from "react";
import { GetSwiggyHeadersResponsePayload } from "@swiggy-private/native-bridge/dist/interfaces";

interface SwiggyHeadersContextType {
    headers: GetSwiggyHeadersResponsePayload | undefined;
    setHeaders: (headers: GetSwiggyHeadersResponsePayload | undefined) => void;
}

const SwiggyHeadersContext = createContext<SwiggyHeadersContextType | undefined>(undefined);

export const useSwiggyHeaders = () => {
    const context = useContext(SwiggyHeadersContext);
    if (!context) {
        throw new Error("useSwiggyHeaders must be used within a SwiggyHeadersProvider");
    }
    return context;
};

interface SwiggyHeadersProviderProps {
    children: React.ReactNode;
    value: SwiggyHeadersContextType;
}

export const SwiggyHeadersProvider: React.FC<SwiggyHeadersProviderProps> = ({ children, value }) => {
    return <SwiggyHeadersContext.Provider value={value}>{children}</SwiggyHeadersContext.Provider>;
};
